var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extr-nav"},[_c('kt-table',{ref:"kt-table",attrs:{"p_appEntKey":"extr","p_cols":_vm.c_ktColumns,"p_opts":_vm.c_ktOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }